export const TYPE = 'FILTER_TYPE';
export const CLEAR = 'FILTER_CLEAR';
export const STATE_PRISTINE = 'FILTER_STATE_PRISTINE';
export const SIRE = 'FILTER_SIRE';
export const STALLION = 'FILTER_STALLION';
export const SIRE_TYPE = 'FILTER_SIRE_TYPE';
export const SIRE_LINE_FLAG = 'FILTER_SIRE_LINE_FLAG';
export const SIRE_LINE = 'FILTER_SIRE_LINE';
export const WIN_DIST = 'FILTER_WIN_DIST';
export const YEAR_TO_STUD = 'FILTER_YEAR_TO_STUD';
export const COUNTRY = 'FILTER_COUNTRY';
export const STUD_FARM = 'FILTER_STUD_FARM';
export const STUD_FEE = 'STUD_FEE';
export const PROGENY_SUCCESS = 'FILTER_PROGENY_SUCCESS';
export const SET_ADVANCED_SECTION = 'SET_ADVANCED_SECTION';
export const SET_FILTER_POPOVER = 'SET_FILTER_POPOVER';



// WEBPACK FOOTER //
// ./src/client/actions/filter/index.js